import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useIsPreviewing } from '@builder.io/react';
import { css } from '@emotion/react';
import { Spinner } from '@zapier/design-system';
import { useRouter } from 'next/router';
import { Entry } from './Entry';
import { useEffect } from 'react';
import { useTracking } from '../tracking';
import { withRendererContext } from './RendererContext';
import { withErrorBoundary } from '../ErrorBoundary';
export function SectionUnwrapped(props) {
    const router = useRouter();
    const isPreviewing = useIsPreviewing();
    const { emitPackageComponentLoadEvent } = useTracking();
    useEffect(() => {
        emitPackageComponentLoadEvent({
            event_action: 'load',
        });
    }, [emitPackageComponentLoadEvent]);
    if (router.isFallback)
        return _jsx(FallbackSection, {});
    if (!props.content && !isPreviewing)
        return null;
    return _jsx(Entry, Object.assign({}, props));
}
export function FallbackSection() {
    return (_jsx("div", Object.assign({ css: css({
            height: '100%',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }) }, { children: _jsx(Spinner, { size: "large" }) })));
}
export const Section = withErrorBoundary(withRendererContext(SectionUnwrapped));
//# sourceMappingURL=Section.js.map